import { hasValueAndNotEmpty } from "@itk/typescript-utils";
import { getAccessToken } from "src/backend/configure-openapi";
import { store } from "src/store";

// Header set for calls made with overlayedFetch instead of the generated client (multipart upload,
// file download). deko-x-backend rejects customer-scoped requests that arrive without x-customerId,
// so those call sites have to carry the same scope headers OpenAPI.HEADERS attaches to generated
// calls. The customerId lookup is repeated from configure-openapi rather than shared, because
// nothing under src/backend can be edited - npm run generate overwrites it.
export const getManualFetchHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = { Authorization: `Bearer ${getAccessToken()}` };

  const currentCustomer = store.getState().generalReducer.applicationReducer.currentCustomer;
  if (currentCustomer.loading === "has-loaded" && hasValueAndNotEmpty(currentCustomer.data.customerId)) {
    headers["x-customerId"] = currentCustomer.data.customerId;
  }

  return headers;
};
